import { on } from '@ngrx/store';

import { LoadingState } from 'src/app/utilities/state.util';

import { UserPageSimilarCustomersActions } from './user-page-similar-customers.actions';
import { UserPageSimilarCustomersState } from './user-page-similar-customers.state';

export const userPageSimilarCustomersReducers = [
    on(
      UserPageSimilarCustomersActions.tabOpened,
      (state: UserPageSimilarCustomersState, { user }): UserPageSimilarCustomersState => ({
            ...state,
            sourceUser: user,
            search: '',
            customers: [],
            loading: LoadingState.INIT,
        }),
    ),
    on(
      UserPageSimilarCustomersActions.searchInputChanged,
      (state: UserPageSimilarCustomersState, { value }): UserPageSimilarCustomersState => ({
            ...state,
            search: value,
        }),
    ),
    on(
      UserPageSimilarCustomersActions.searchSimilarCustomersStarted,
      (state: UserPageSimilarCustomersState): UserPageSimilarCustomersState => ({
            ...state,
            loading: LoadingState.LOADING,
        }),
    ),
    on(
      UserPageSimilarCustomersActions.searchSimilarCustomersSuccess,
      (state: UserPageSimilarCustomersState, { customers }): UserPageSimilarCustomersState => ({
            ...state,
            customers,
            loading: LoadingState.LOADED,
        }),
    ),
    on(
      UserPageSimilarCustomersActions.searchSimilarCustomersError,
      (state: UserPageSimilarCustomersState): UserPageSimilarCustomersState => ({
            ...state,
            customers: [],
            loading: LoadingState.LOADED,
        }),
    ),
];
